import { Typography } from 'antd'
import { SingleTaxonomyPanel } from './TaxonomiesTab'

const { Title } = Typography

/** LiangCollection "条目分类" (Category) — its own routed page, independent
 * from "主题分类管理" (Topic), matching Legacy's real sidebar IA (spec §1/§13). */
export default function CategoriesTab({ workspaceId, siteId }: { workspaceId: string; siteId: string }) {
  return (
    <div>
      <Title level={4} style={{ marginTop: 0 }}>条目分类</Title>
      <SingleTaxonomyPanel workspaceId={workspaceId} siteId={siteId} taxonomyKey="category" taxonomyName="条目分类" />
    </div>
  )
}
